<script>
import { logListComputed, logListMethods } from '@state/helpers/log-list'
import SearchPayload from '@utils/searchPayload'
import { ObjectHelper } from '@utils/helpers'
import cloneDeep from 'lodash/cloneDeep'
import tableFields from './tableFields'

export default {
  page: {
    title: 'Log',
    meta: [{ name: 'description', content: 'The Log page.' }],
  },
  data() {
    return {
      items: {},
      searchBody: new SearchPayload.Builder().withAdminId().build(),
      fields: cloneDeep(tableFields),
      options: [
        {
          value: '0',
          label: '全て',
        },
        {
          value: '1',
          label: '自身',
        },
      ],
      value: '',
    }
  },
  computed: {
    ...logListComputed,
    logListData() {
      const list =
        cloneDeep(this.getLogList?.list)?.map((item) => {
          item.company = !item.company ? '-' : item.company
          item.admin_name = item.admin_name + '/' + item.admin_display_name
          return item
        }) || []
      return list
    },
    paginationComputed() {
      let paginations = {}
      if (this.getLogList) {
        paginations = ObjectHelper.removePropertyByKey('list')(this.getLogList)
      }
      return paginations
    },
    loadingComputed() {
      return this.loading
    },
  },
  created() {
    const user = this.$store.getters['auth/getCurrentUser']
    if (user.level !== 0) {
      this.fields.splice(1, 1)
    }
    this.value = '0'
    this.searchBody.admin_id = 0
    this.handleLogList()
    this.$router
      .replace({
        query: { agent_code: user?.agent?.agent_code },
      })
      .catch(() => {})
  },
  methods: {
    ...logListMethods,
    handlePagination(body) {
      this.searchBody = { ...this.searchBody, ...body }
      this.handleLogList()
    },
    handleAdminId(value) {
      const user = this.$store.getters['auth/getCurrentUser']
      if (this.value === '0') {
        this.searchBody = { ...this.searchBody, admin_id: 0 }
      } else {
        this.searchBody = { ...this.searchBody, admin_id: user.id.toString() }
      }
      this.handleLogList()
    },
    handleLogList() {
      this.fetchingLogList(this.searchBody)
    },
    handleUpdate(value) {
      this.handleAdminId(value)
    },
  },
}
</script>

<template>
  <div>
    <CCard class="radio-box">
      <CRow class="d-flex justify-content-between align-items-baseline">
        <h6 class="font-weight-bold">操作履歴</h6>
        <div class="d-flex align-items-center">
          <label class="mr-3">表示切替</label>
          <BaseRadioGroup
            inline
            :options="options"
            :checked.sync="value"
            custom
            @update:checked="(v) => handleUpdate(v)"
          />
        </div>
      </CRow>
    </CCard>
    <BasePagination
      :paginations="paginationComputed"
      @activePagination="handlePagination"
    >
    </BasePagination>
    <BaseTable
      striped
      border
      :loading="loadingComputed"
      :table-fields="fields"
      :data-tables="logListData"
    >
    </BaseTable>
  </div>
</template>

<style lang="scss" scoped>
.radio-box {
  width: 100%;
  padding: 15px 40px;
  background-color: $feelline-bg-primary;
  border-radius: 0.25rem;
  h6 {
    padding: 0;
    margin: 0;
    font-size: 1rem;
    color: $custom-filter-box-card-title-color;
  }
  label {
    margin-bottom: 0;
  }
  ::v-deep .form-group {
    margin-bottom: 0;
  }
}
</style>
